"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_OWNER = exports.NULL_IDENTIFIER = exports.NULL_ADDRESS = exports.NULL_TOPIC = exports.NULL_STAMP = exports.SWARM_GATEWAY_URL = void 0;
const typed_bytes_1 = require("./typed-bytes");
exports.SWARM_GATEWAY_URL = 'https://api.gateway.ethswarm.org';
exports.NULL_STAMP = new typed_bytes_1.BatchId('0000000000000000000000000000000000000000000000000000000000000000');
exports.NULL_TOPIC = new typed_bytes_1.Topic('0000000000000000000000000000000000000000000000000000000000000000');
exports.NULL_ADDRESS = new Uint8Array(32);
exports.NULL_IDENTIFIER = new Uint8Array(32);
exports.NULL_OWNER = new Uint8Array(20);
